/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { useLocation, useNavigate } from "react-router-dom";
import queryString from 'query-string';
import { useContext, useEffect, useState } from "react";
import { BrujoContext } from "../Context/BrujoContext";

export const DetalleArticulo = ({ocultarViewDetalle}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { detalle = '' } = queryString.parse( location.search );

  const { searchPiezaId, findItemLocation } = useContext(BrujoContext);

  const [titleArticle, setTitleArticle] = useState({
    tCultura: '',
    tMaterial: '',
    tPeriodo: '',
    tObjeto: '',
    tProveniencia: ''
  })

  const [detalleArticle, setDetalleArticle] = useState({
    cul_name: '',
    imagen: [],
    mat_tipo: '',
    per_name: '',
    pie_code: '',
    pie_desc_objeto: '',
    pie_id: 0,
    pie_sector: '',
    provenienciaNombre: '',
    tob_name: '',
  });

  const [selectedImage, setSelectedImage] = useState('');

  const [onIdenti, setOnIdenti] = useState(true);
  const [onAfo, setOnAfo] = useState(false);
  const [onContexto, setContexto] = useState(false);

  useEffect(() => {
    searchDetalleArticle();
  }, []);

  useEffect(() => {
    showItemPath();
  }, [location.search])  

  useEffect(() => {
    const detalle = document.getElementById("detalle");

    if (detalle) {
      navigate(`${location.pathname}${location.search}`);
      window.location.hash = "#detalle";
    }
  }, [])

  const searchDetalleArticle = async() => {
    const resp = await searchPiezaId(detalle);
    setSelectedImage(resp.imagen[0]);
    return setDetalleArticle({
      cul_name: resp.cul_name,
      imagen: resp.imagen,
      mat_tipo: resp.mat_tipo,
      per_name: resp.per_name,
      pie_code: resp.pie_code,
      pie_desc_objeto: resp.pie_desc_objeto,
      pie_id: resp.pie_id,
      pie_sector: resp.pie_sector,
      provenienciaNombre: resp.provenienciaNombre,
      tob_name: resp.tob_name,
    })
  }

  const showItemPath = async() => {
    setTitleArticle({
      tCultura: await findItemLocation('tcultura'),
      tMaterial: await findItemLocation('tmaterial'),
      tPeriodo: await findItemLocation('tperiodo'),
      tObjeto: await findItemLocation('tobjeto'),
      tProveniencia: await findItemLocation('tproveniencia')
    })
  }

  return (
    <div id="detalle" className="viewDetalleContainer">
      <div className="navigateDetalle">
        <div className="backDetalle" onClick={ocultarViewDetalle}>
          <ion-icon name="home-outline"></ion-icon>  
        </div>
        {
          titleArticle.tCultura !== ''
            ? <>
                <ion-icon name="chevron-forward-outline"></ion-icon>
                <p>{titleArticle.tCultura}</p>
              </>
            : <></>
        }
        {
          titleArticle.tMaterial !== ''
            ? <>
                <ion-icon name="chevron-forward-outline"></ion-icon>
                <p>{titleArticle.tMaterial}</p>
              </>
            : <></>
        }
        {
          titleArticle.tPeriodo !== ''
            ? <>
                <ion-icon name="chevron-forward-outline"></ion-icon>
                <p>{titleArticle.tPeriodo}</p>
              </>
            : <></>
        }
        {
          titleArticle.tObjeto !== ''
            ? <>
                <ion-icon name="chevron-forward-outline"></ion-icon>
                <p>{titleArticle.tObjeto}</p>
              </>
            : <></>
        }
        {
          titleArticle.tProveniencia !== ''
            ? <>
                <ion-icon name="chevron-forward-outline"></ion-icon>
                <p>{titleArticle.tProveniencia}</p>
              </>
            : <></>
        }
        <ion-icon name="chevron-forward-outline"></ion-icon>
        <p>{ detalleArticle.pie_code }</p>
      </div>
      <div className="detalleArticulo">
        <div className="leftOrden">
          <div className="imageZoom">
            {
              (selectedImage !== undefined)
                ? <img src={ selectedImage } alt={ detalleArticle.cul_name } className="zoomImagenDisponible" />
                : <img src='./assets/img/no-imagen.jpg' alt={detalleArticle.cul_name}/>
            }            
          </div>
          <div className="listImages">
            {
              detalleArticle.imagen.map((item, index) => {
                return (
                  <div key={index} onClick={() => { setSelectedImage(item) }} className={"imageItem " + ((selectedImage === item) ? "selectedImageActive" : "nSelectedImage")}>
                    {
                      (item !== undefined)
                        ? <img src={ item } alt={ index } />
                        : <img src='./assets/img/no-imagen.jpg' className='imgArticles' alt={item.cul_name}/>
                    }
                  </div>
                )
              })
            }
          </div>
        </div>
        <div className="rightOrden">
          <div className="encabezado">
            Código de Registro: {detalleArticle.pie_code}
          </div>

          <div className="contDescrip">
            <div className="titleDescrip" onClick={() => {setOnIdenti(!onIdenti); setOnAfo(false); setContexto(false)}}>
              <p>Datos de Identificación</p>
              <ion-icon name="chevron-down-outline"></ion-icon>
            </div>
            <div className={"description " + ((onIdenti) ? "animate__animated animate__slideInDown" : "animate__animated animate__slideOutUp invisible")}>
              <table>
                <tbody>
                  <tr>
                    <td className="ti">Tipo de Objeto:</td>
                    <td className="val"><b>{detalleArticle.tob_name}</b></td>
                  </tr>
                  <tr>
                    <td className="ti">Material:</td>
                    <td className="val"><b>{detalleArticle.mat_tipo}</b></td>
                  </tr>
                  <tr>
                    <td className="ti">Filiación Cultural:</td>
                    <td className="val"><b>{detalleArticle.cul_name}</b></td>
                  </tr>
                  <tr>
                    <td className="ti">Periodo:</td>
                    <td className="val"><b>{detalleArticle.per_name}</b></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="contDescrip">
            <div className="titleDescrip" onClick={() => {setOnAfo(!onAfo); setOnIdenti(false); setContexto(false)}}>
              <p>Aspectos Físicos del Objeto</p>
              <ion-icon name="chevron-down-outline"></ion-icon>
            </div>
            <div className={"description " + ((onAfo) ? "animate__animated animate__slideInDown" : "animate__animated animate__slideOutUp invisible")}>
              { detalleArticle.pie_desc_objeto }
            </div>
          </div>

          <div className="contDescrip">
            <div className="titleDescrip" onClick={() => {setContexto(!onContexto); setOnIdenti(false); setOnAfo(false)}}>
              <p>Contexto</p>
              <ion-icon name="chevron-down-outline"></ion-icon>
            </div>
            <div className={"description " + ((onContexto) ? "animate__animated animate__slideInDown" : "animate__animated animate__slideOutUp invisible")}>
              <table>
                <tbody>
                  <tr>
                    <td className="ti">Procedencia:</td>
                    <td className="val"><b>{detalleArticle.provenienciaNombre}</b></td>
                  </tr>
                  <tr>
                    <td className="ti">Sector:</td>
                    <td className="val"><b>{detalleArticle.pie_sector}</b></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
